import { configureStore, createSlice } from '@reduxjs/toolkit'
import createSagaMiddleware from 'redux-saga'
import rootSaga from '../_sagas'
import { logger } from 'redux-logger'

const initialState = {
    loading: true,
    ProductionData: [],
    phoneNumbers: [],
    farmers: [],
    farmersFailed: null,
    displayModal: null,
    purchaseTools: [],
    purchaseSeeds: [],
    labor: [],
    labor2: [],
    harvestTools: [],
    revenue: []
}

const AppSlice = createSlice( {
    name: "app",
    initialState,
    reducers: {
        setProductionData: ( state, action ) => {
        },
        addSMSNumbers: ( state, action ) => {
            state.phoneNumbers = action.payload
        },
        getRegisteredFarmers: ( state, action ) => {
            // state.loading = true
        },
        getRegisteredSuccess: ( state, action ) => {
            state.farmers = action.payload
            state.loading  = false
        },
        getRegisteredFailed: ( state, action ) => {
            state.farmersFailed = action.payload
            // state.loading = false
        },
        setDisplayModal: ( state, action ) => {
            state.displayModal = {
                title: action.payload.title,
                flag: action.payload.flag,
                tag: action.payload.tag
            }
        },
        setSavePurchase: ( state, action ) => {
            state.purchaseTools = action.payload 
        },
        removePurchaseItem: ( state, action ) => {
            state.purchaseTools.splice( action.payload.idx, 1 )
        },
        setSavePurchaseSeeds: ( state, action ) => {
            state.purchaseSeeds = action.payload
        },
        removePurchaseSeeds: ( state, action ) => {
            state.purchaseSeeds.splice( action.payload.idx, 1 )
        },
        setSaveLabor: ( state, action ) => {
            state.labor = action.payload
        },
        removeLabor: ( state, action ) => {
            state.labor.splice( action.payload.idx, 1 )
        },
        setHarvestTools: ( state, action ) => {
            state.harvestTools = action.payload
        },
        removeHarvest: ( state, action ) => {
            state.harvestTools.splice( action.payload.idx, 1 )
        },
        setSaveLabor2: ( state, action ) => {
            state.labor2 = action.payload
        },
        removeLabor2: ( state, action ) => {
            state.labor2.splice( action.payload.idx, 1 )
        },
        setSaveRevenue: ( state, action ) => {
            state.revenue = action.payload
        },
        removeRevenue: ( state, action ) => {
            state.revenue.splice( action.payload.idx, 1 )
        },
    }
} )

export const { 
    setProductionData, addSMSNumbers, 
    getRegisteredFarmers, getRegisteredSuccess, getRegisteredFailed,
    setDisplayModal, setSavePurchase, removePurchaseItem,
    setSavePurchaseSeeds, removePurchaseSeeds, setSaveLabor,
    removeHarvest, setHarvestTools, setSaveLabor2, removeLabor2,
    setSaveRevenue, removeRevenue
} = AppSlice.actions

const sagaMiddleware = createSagaMiddleware()

//declare the store with reducer and middleware
const store  = configureStore( {
    reducer: {
        application: AppSlice.reducer
    },
    middleware: getDefaultMiddleware => getDefaultMiddleware().concat( 
        sagaMiddleware,
        logger
    )
} )

//run the saga middleware
sagaMiddleware.run( rootSaga )

export default store